import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const ReikiSessions = () => {
  const rates = [
    { 
      time: "30 Minutes", 
      price: "$77", 
      icon: "Clock",
      link: "https://app.acuityscheduling.com/schedule.php?owner=39722108&appointmentType=95172743"
    },
    { 
      time: "60 Minutes", 
      price: "$111", 
      icon: "Activity",
      link: "https://app.acuityscheduling.com/schedule.php?owner=39722108&appointmentType=95178646"
    },
    { 
      time: "90 Minutes", 
      price: "$144", 
      icon: "Zap",
      link: "https://app.acuityscheduling.com/schedule.php?owner=39722108&appointmentType=95178672"
    }
  ];

  return (
    <section id="reiki" className="py-32 px-4 relative overflow-hidden bg-[#0a0515]">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-5xl md:text-7xl font-black mb-8 leading-none uppercase tracking-tighter">
              Reiki <span className="text-gradient">Sessions.</span>
            </h2>
            <p className="text-slate-400 text-xl font-light mb-12 italic">
              "Master your energy. Transform your spirit."
            </p>
            
            <div className="space-y-8">
              <div className="glass-panel p-8 rounded-3xl border-l-[6px] border-l-emerald-400">
                <h4 className="text-slate-500 text-xs font-bold uppercase tracking-widest mb-4">Operating Hours</h4>
                <div className="space-y-3">
                  <div className="flex justify-between items-center border-b border-white/5 pb-2">
                    <span className="text-white font-medium">Monday - Friday</span>
                    <span className="text-emerald-400 font-mono">10:00 am - 6:00 pm</span>
                  </div>
                  <div className="flex justify-between items-center text-slate-400">
                    <span>Sat / Sun</span>
                    <span className="italic">By Appointment Only</span>
                  </div>
                  <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-4">
                    Central Std. Time / Chicago Zone
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="https://app.acuityscheduling.com/schedule.php?owner=39722108" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 px-8 py-5 rounded-2xl bg-white text-black font-bold text-center hover:scale-105 transition-transform"
                >
                  View All Services
                </a>
                <a 
                  href="tel:5122280573" 
                  className="flex-1 px-8 py-5 rounded-2xl glass-panel text-white font-bold text-center border-white/10 hover:bg-white/5 transition-colors"
                >
                  Call to Schedule
                </a>
              </div>
            </div>
          </motion.div>

          <div className="grid gap-6">
            {rates.map((rate, i) => (
              <motion.a
                key={i}
                href={rate.link}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="group relative glass-panel p-8 rounded-[2.5rem] hover:border-emerald-500/30 transition-all overflow-hidden block"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="flex items-center justify-between relative z-10">
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <SafeIcon name={rate.icon} className="w-8 h-8 text-emerald-400" />
                    </div>
                    <div>
                      <h4 className="text-2xl font-black text-white uppercase tracking-tighter">{rate.time}</h4>
                      <p className="text-slate-500 text-sm">Book on Acuity Scheduling</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-white tracking-tighter">{rate.price}</p>
                    <div className="flex items-center gap-2 text-emerald-400 font-bold uppercase tracking-widest text-[10px] justify-end">
                      Book Now <SafeIcon name="ArrowRight" className="w-3 h-3" />
                    </div>
                  </div>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReikiSessions;